<template>
  <div class="pa-md-8 pa-4" style="background-color: #f7f8fc; min-height: 100vh">
    <div v-if="isLoading" class="d-flex flex-column justify-center align-center" style="height: 80vh">
      <v-progress-circular indeterminate color="primary" :size="70" :width="7"></v-progress-circular>
      <p class="mt-4 text-h6 text-grey-darken-1">Buchungen werden geladen...</p>
    </div>

    <div v-else>
      <v-text-field
        v-model="searchQuery"
        label="Suche nach Raum, Titel oder Teilnehmer..."
        prepend-inner-icon="mdi-magnify"
        variant="solo"
        clearable
        class="mb-8"
        elevation="2"></v-text-field>

      <v-row v-if="filteredList.length > 0">
        <v-col cols="12" sm="6" lg="4" v-for="entry in filteredList" :key="entry._id">
          <v-card @click="openEditDialog(entry)" class="d-flex flex-column fill-height" variant="elevated" elevation="3">
            <v-card-title class="d-flex align-center font-weight-bold">
              <v-icon start>mdi-home-outline</v-icon>
              {{ entry.title }}
            </v-card-title>
            <v-card-subtitle>{{ entry.subtitle }}</v-card-subtitle>
            <v-divider class="mx-4"></v-divider>
            <v-card-text>
              <div class="mb-3 d-flex align-center">
                <v-icon small class="mr-2 text-grey-darken-1">mdi-calendar-range</v-icon>
                <strong>{{ entry.dateRange[0] }} - {{ entry.dateRange[1] }}</strong>
              </div>
              <div class="d-flex align-start">
                <v-icon small class="mr-2 mt-1 text-grey-darken-1">mdi-account-group</v-icon>
                <div>
                  <v-chip v-for="(person, i) in entry.persons" :key="i" class="ma-1" color="indigo-lighten-5" size="small">
                    {{ person.firstName }} {{ person.lastName }}
                  </v-chip>
                </div>
              </div>
            </v-card-text>
            <v-spacer></v-spacer>
            <v-card-actions class="pa-3">
              <v-btn block variant="tonal" color="primary" prepend-icon="mdi-pencil-outline"> Bearbeiten </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <div v-else class="text-center pa-16">
        <v-icon size="60" color="grey-lighten-1">mdi-database-search-outline</v-icon>
        <p class="mt-4 text-h6 text-grey-darken-1">Keine Buchungen gefunden</p>
        <p class="text-grey">Deine Suche nach "{{ searchQuery }}" ergab keine Treffer.</p>
      </div>
    </div>

    <v-dialog v-model="dialogVisible" persistent max-width="900px" transition="dialog-bottom-transition">
      <v-card v-if="selectedEntry">
        <v-card-title class="d-flex align-center justify-space-between text-h5 pa-4">
          <span>
            <v-icon start color="primary">mdi-calendar-edit</v-icon>
            Buchung bearbeiten
          </span>
          <v-btn icon="mdi-close" variant="text" @click="dialogVisible = false"></v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-4" style="max-height: 65vh; background-color: #fdfdfd">
          <v-row>
            <v-col cols="12" sm="6" md="4"
              ><v-text-field
                prepend-inner-icon="mdi-calendar-arrow-right"
                label="von"
                v-model="selectedEntry.dateRange[0]"
                variant="outlined"
                density="compact"></v-text-field
            ></v-col>
            <v-col cols="12" sm="6" md="4"
              ><v-text-field
                prepend-inner-icon="mdi-calendar-arrow-left"
                label="bis"
                v-model="selectedEntry.dateRange[1]"
                variant="outlined"
                density="compact"></v-text-field
            ></v-col>
            <v-col cols="12" sm="6" md="4"
              ><v-text-field
                prepend-inner-icon="mdi-clock-time-eight-outline"
                label="Dauer"
                v-model="selectedEntry.duration"
                variant="outlined"
                density="compact"></v-text-field
            ></v-col>
            <v-col cols="12" sm="6" md="4"
              ><v-text-field
                prepend-inner-icon="mdi-home"
                label="Raum"
                v-model="selectedEntry.title"
                variant="outlined"
                density="compact"></v-text-field
            ></v-col>
            <v-col cols="12" sm="6" md="4"
              ><v-text-field
                prepend-inner-icon="mdi-subtitles"
                label="Untertitel"
                v-model="selectedEntry.subtitle"
                variant="outlined"
                density="compact"></v-text-field
            ></v-col>
            <v-col cols="12" sm="6" md="4"
              ><v-text-field
                prepend-inner-icon="mdi-cash"
                label="Preis pro Tag"
                v-model="selectedEntry.pricePerDay"
                variant="outlined"
                density="compact"
                prefix="CHF"></v-text-field
            ></v-col>
          </v-row>
          <v-divider class="my-4"></v-divider>
          <p class="text-h6 mb-2">Teilnehmer</p>
          <div v-for="(person, i) of selectedEntry.persons" :key="i" class="my-4 pa-4 border rounded">
            <p class="mb-3 font-weight-bold">Person {{ i + 1 }}</p>
            <v-row>
              <v-col cols="12" sm="6"
                ><v-text-field
                  prepend-inner-icon="mdi-account"
                  label="Vorname"
                  v-model="person.firstName"
                  variant="outlined"
                  density="compact"></v-text-field
              ></v-col>
              <v-col cols="12" sm="6"
                ><v-text-field label="Nachname" v-model="person.lastName" variant="outlined" density="compact"></v-text-field
              ></v-col>
              <v-col cols="12" sm="4"
                ><v-text-field
                  prepend-inner-icon="mdi-cake-variant"
                  label="Geburtsdatum"
                  v-model="person.birthDayPicker.date"
                  variant="outlined"
                  density="compact"></v-text-field
              ></v-col>
              <v-col cols="12" sm="4"
                ><v-text-field prepend-inner-icon="mdi-numeric" label="Alter" v-model="person.age" variant="outlined" density="compact"></v-text-field
              ></v-col>
              <v-col cols="12" sm="4"
                ><v-text-field
                  prepend-inner-icon="mdi-tshirt-crew"
                  label="T-Shirt"
                  v-model="person.shirtSize"
                  variant="outlined"
                  density="compact"></v-text-field
              ></v-col>
            </v-row>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4" style="background-color: #f7f8fc">
          <v-btn color="red" class="white--text" @click="deleteFormEntry(selectedEntry)" prepend-icon="mdi-delete-outline">Löschen</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogVisible = false">Abbrechen</v-btn>
          <v-btn color="primary" flat @click="updateFormEntry(selectedEntry)" prepend-icon="mdi-content-save">speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "../../api"
export default {
  name: "aliBeyEditor",
  data() {
    return {
      formattedList: [], // Sicherstellen, dass es immer ein Array ist
      backupList: [],
      isLoading: true,
      dialogVisible: false,
      selectedEntry: null,
      searchQuery: "", // NEU: Für die Suchfunktion
    }
  },
  computed: {
    // NEU: Berechnete Eigenschaft für die Live-Suche
    filteredList() {
      if (!this.searchQuery) {
        return this.formattedList
      }
      const lowerCaseQuery = this.searchQuery.toLowerCase()
      return this.formattedList.filter((entry) => {
        const inTitle = entry.title.toLowerCase().includes(lowerCaseQuery)
        const inSubtitle = entry.subtitle.toLowerCase().includes(lowerCaseQuery)
        const inPersons = entry.persons.some(
          (person) => person.firstName.toLowerCase().includes(lowerCaseQuery) || person.lastName.toLowerCase().includes(lowerCaseQuery)
        )
        return inTitle || inSubtitle || inPersons
      })
    },
  },
  async created() {
    await this.fetchAlibeyList()
  },
  methods: {
    openEditDialog(entry) {
      this.selectedEntry = JSON.parse(JSON.stringify(entry))
      this.dialogVisible = true
    },

    async deleteFormEntry(entry) {
      if (window.confirm(`Soll die Buchung für "${entry.title}" wirklich gelöscht werden?`)) {
        await api.deleteListEntry({ category: "alibey", _id: entry._id })
        this.dialogVisible = false
        await this.fetchAlibeyList()
      }
    },
    async updateFormEntry(entry) {
      return this.$toast.error("Diese Funktion ist noch nicht implementiert.")
      return
      console.log("Updating entry:", entry)
      const oldEntry = this.backupList.find((e) => e._id === entry._id)
      for (let key in entry) {
        if (JSON.stringify(entry[key]) !== JSON.stringify(oldEntry[key])) {
          console.log("CHANGED THIS", key)
        }
      }

      let upateEntry = {
        _id: entry._id,
        content: {
          dateRange: entry.dateRange,
          form: {
            persons: entry.persons.map((person) => ({
              firstName: person.firstName,
              lastName: person.lastName,
              birthDayPicker: { date: person.birthDayPicker.date },
              age: person.age,
              shirtSize: person.shirtSize,
            })),
          },
          duration: entry.duration,
          room: {
            title: entry.title,
            subtitle: entry.subtitle,
            possibility: { price: parseFloat(entry.pricePerDay) },
          },
        },
      }
      await api.updateListEntry(upateEntry)

      this.dialogVisible = false
      await this.fetchAlibeyList() // Liste neu laden, um Änderungen zu sehen
    },

    async fetchAlibeyList() {
      this.isLoading = true
      try {
        const list = (await api.downloadListCategory("alibey")) || [] // Fallback auf leeres Array
        this.formattedList = list.map((item) => ({
          _id: item._id,
          dateRange: item.content.dateRange,
          persons: item.content.form.persons,
          duration: item.content.duration,
          subtitle: item.content.room.subtitle ? item.content.room.subtitle : "",
          title: item.content.room.title,
          pricePerDay: item.content.room.possibility.price.toString(),
          room: item.content.room,
        }))
        this.backupList = JSON.parse(JSON.stringify(this.formattedList))
      } catch (e) {
        console.error("Fehler beim Laden der Alibey-Nachrichten:", e)
        this.formattedList = [] // Bei Fehler leere Liste anzeigen
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style scoped>
.fill-height {
  height: 100%;
}
</style>
